import { auth } from "auth"
import { v3 } from "backoffice-api"
import { invalidateAllQueries } from "bonzai"
import i18next from "i18next"
import { PORTAL_LOCALE_KEY } from "./constants"
import { loadLocales } from "./loadLocales"
import { setDocumentLanguageAndDirection } from "./setDocumentLanguageAndDirection"

export const changeLocale = async (locale: string) => {
  await loadLocales([locale])
  i18next.changeLanguage(locale)

  auth.updateConfig({ locale })
  await setDocumentLanguageAndDirection(locale)

  try {
    await updateServerLocale(locale)
  } catch (err) {
    console.error("Failed to update server locale", err)
  }

  invalidateAllQueries()
}

const updateServerLocale = async (locale: string) => {
  const userSettings = await v3.getUserSettings()
  const locales = {
    ...userSettings.data.locales,
    [PORTAL_LOCALE_KEY]: locale,
  }
  await v3.updateUserSettings({ locales })
}
